import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-green-number',
  templateUrl: './green-number.component.html',
  styleUrls: ['./green-number.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GreenNumberComponent {
  @Input() title = "Vous vous posez des questions sur votre avenir ? Vous avez besoin d'informations et de conseils ?";
  @Input() text = 'Un seul numéro pour trouver votre solution.';
}

@NgModule({
  imports: [CommonModule, MatIconModule],
  declarations: [GreenNumberComponent],
  exports: [GreenNumberComponent],
})
export class GreenNumberModule {}
